import React from "react";

const DialogoChoosePhone = (params) => {
  return (
    <div id="dialogoChoosePhone" className="modal" tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div
          style={{ backgroundColor: "#eeeeee", color: "green" }}
          className="modal-content"
        >
          <div className="modal-header">
            <h5 style={{ textAlign: "center" }}>
              Elije un télefono
            </h5>
            <svg
              data-dismiss="modal"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              className="bi bi-x-square"
              viewBox="0 0 16 16"
              style={{marginTop: "-0.8em", cursor: "pointer"}}
            >
              <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
            </svg>
          </div>
          <div style={{ textAlign: "center" }} className="modal-body">
            {params.telefonos.map((item, index) => {
              return (
                <div key={index}>
                  <button
                    style={{ marginBottom: "0.2em" }}
                    onClick={() => params.choosePhone(item)}
                    className="btn btn-outline-success"
                    data-dismiss="modal"
                  >
                    <span style={{ display: "flex" }}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-telephone-fill"
                        viewBox="0 0 16 16"
                        style={{
                          color: "green",
                          marginRight: "0.4em",
                          marginTop: "0.2em",
                        }}
                      >
                        <path
                          fillRule="evenodd"
                          d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"
                        />
                      </svg>
                      {item}
                    </span>
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <button
        id="btnDialogoChoosePhone"
        data-toggle="modal"
        data-target="#dialogoChoosePhone"
        style={{ display: "none" }}
      ></button>
    </div>
  );
};

export default DialogoChoosePhone;
